import { memo, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import check from 'check-types';
import { Alert, Panel } from '@sdflc/ui';

import { LocalizationContext } from '../../../contexts';
import { UserLocationItem } from './UserLocationItem';

const tplUserLocations = Array.from({ length: 2 }).map((_, idx) => ({
  id: idx,
  locationId: null,
  locationTypeId: 'home',
  notes: '',
  isDefault: false,
  location: {
    countryId: null,
    postalCode: '',
    address2: '',
    longitude: '',
    latitude: '',
    status: 100,
    l10n: {
      locationId: null,
      lang: 'en',
      state: '',
      city: '',
      address1: '',
      address2Name: '',
    },
  },
}));

const UserLocationList = memo((props) => {
  const { onClickAction, list, items, listOp, removingOps } = props;
  const { getText } = useContext(LocalizationContext);

  useEffect(() => {
    // Load user locations if they were not yet loaded

    if (!listOp.called && check.function(list)) {
      list({
        filter: {},
        params: {},
      });
    }
  }, [list, listOp]);

  if (
    listOp.called &&
    !listOp.result.isInProgress() &&
    listOp.result.didFail()
  ) {
    return <Alert variant='danger'>{listOp.result.getErrorSummary()}</Alert>;
  }

  const items2use = listOp.result?.isInProgress() ? tplUserLocations : items;

  return (
    <Panel mt={2} p={1} overflow='initial'>
      {items2use.map((item) => {
        return (
          <UserLocationItem
            key={item.id}
            value={item}
            onClickAction={onClickAction}
            loading={listOp.result?.isInProgress()}
            removingResult={removingOps[item.id]?.result}
          />
        );
      })}
      {!listOp.result?.isInProgress() && items.length === 0 && (
        <Alert variant='default'>
          {getText('pages.userLocations.noLocations')}
        </Alert>
      )}
    </Panel>
  );
});

UserLocationList.displayName = 'UserLocationList';

UserLocationList.propTypes = {
  onClickAction: PropTypes.func,
};

UserLocationList.defaultProps = {
  onClickAction: null,
};

export { UserLocationList };
